export default {"src":"/customer-services/_next/static/media/dobbies-store-icon.7608a7c8.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};